import { extractUniDataTableRows } from '@/common/utils/extractUniDataTableRows'

/**
 * Извлекает из ответа middle директивы `reload__elements` — таблицу типа
 * `[{level:'element'|'panel'|'page', id: <long>}]`. Middle возвращает её,
 * когда данные конкретного элемента должны быть перезагружены отдельно
 */
export type ReloadElementsInstruction = {
  level: string
  id: number
}

function readStringField(row: unknown, key: string): string {
  const fields = (row as { fields?: Record<string, { value?: unknown }> })?.fields
  if (!fields) return ''
  const entry = fields[key]
  if (!entry || typeof entry !== 'object') return ''
  return String((entry as { value?: unknown }).value ?? '').trim()
}

function readLongField(row: unknown, key: string): number | null {
  const fields = (row as { fields?: Record<string, { value?: unknown }> })?.fields
  if (!fields) return null
  const entry = fields[key]
  if (!entry || typeof entry !== 'object') return null
  const raw = (entry as { value?: unknown }).value
  const n = Number(raw)
  return Number.isFinite(n) ? n : null
}

/**
 * Достаёт список reload-инструкций из объекта changed_data / ответа middle.
 * Ищет по обоим типовым shape'ам: `{fields: {fields: {reload__elements: {...}}}}`
 * и `{reload__elements: {...}}`.
 */
export function extractReloadElementsInstructions(
  changedData: unknown,
): ReloadElementsInstruction[] {
  if (!changedData || typeof changedData !== 'object') return []
  const flatFields =
    (changedData as { fields?: { fields?: Record<string, unknown> } })?.fields?.fields ??
    (changedData as { fields?: Record<string, unknown> })?.fields ??
    (changedData as Record<string, unknown>)
  if (!flatFields || typeof flatFields !== 'object') return []
  const entry = (flatFields as Record<string, unknown>).reload__elements
  if (!entry) return []
  const rows = extractUniDataTableRows(entry)
  if (!Array.isArray(rows) || rows.length === 0) return []

  const out: ReloadElementsInstruction[] = []
  for (const row of rows) {
    const level = readStringField(row, 'level').toLowerCase()
    const id = readLongField(row, 'id')
    if (!level || id == null) continue
    out.push({ level, id })
  }
  return out
}
